module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Model_List', {

		configure: function () {
			this.registerOptions('', {
				'widgets.dl': {
					widget: 'Datalayer',
					method: 'model.list',
					limit: 15,
				},
				autoRender: true,
				'embed.container': '#model-list',
				list: {
					'tpl.row': 'model_list',
					'handleDom.deleteModel': {						
						target: '.del-model',
						event: 'click',
						callback: '@parent @parent:deleteModel'
					}
				},
				'pager.widget': 'ContentPager'
			})
		
			this.callParent('configure', arguments);
		},
		
		search: function(term) {
			term = fox.trim(term);
			term += '%';
			this.dl.dropFilter('search');

			if (term) {
				this.dl.addFilter('search', ['~realName', '~stageName'], [term, term]);
			}
			
			this.dl.load();
		},
		
		reload: function(filter) {
			// temporary!!!!! do not delete this...
			
			this.dl.dropFilter('modelStatus').addFilter('modelStatus', {
				fields: ['status'],
				values: [filter]
			});

			this.dl.load();
		}
						
	}, 'Grid');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/model/list.js
// module id = 329
// module chunks = 2